import React from 'react';
import { css } from '@emotion/css';
import appLabels from '../../utils/appLabels';
import { isMobile } from '../../utils/utils';

const linkStyle = css`
  font-weight: 400;
  color: #7b1a27 !important;
  line-height: 1rem;
  text-decoration-line: underline;
  border: none;
  background: white;
`;

const footerContainer = css`
  margin-top: 2rem;
`;

const Footer = (props) => {
  const analyticsEvents = () => {
    try {
      if (window['AB']?.DATALAYER) {
        if (props.analyticsState) {
          window['AB'].DATALAYER.analyticsCTATracking(
            'cta:upcoming-orders-previous-enrolled|link|faq-schedule-and-save',
          );
        } else {
          window['AB'].DATALAYER.setLinkClickEvents('ar:subscribe-schedule-and-save|need-help-faq');
        }
      }
    } catch (error) {
      // Handle any errors that occur during execution
      console.error('@AnalyticsTeam error:', error);
    }
  };

  return (
    <div className={footerContainer}>
      <p>
        <span data-testid="need-help">{appLabels.Footer.needHelp}</span>
        <a
          className={`${linkStyle} link-reg`}
          onClick={() => analyticsEvents()}
          href={
            isMobile() ? appLabels.UserWithoutSubscription.aboutLinkMobile : appLabels.UserWithoutSubscription.aboutLink
          }
          data-testid="faq-link"
        >
          <button className={`${linkStyle} link-reg`} aria-label={appLabels.Footer.helpLink}>
            {appLabels.Footer.helpLink}
          </button>
        </a>
      </p>
    </div>
  );
};

export default Footer;
